export default __webpack_public_path__ + "static/media/fast_&_Furious_grap_chart.4e056646.jpg";